import React from 'react';
import { useFlow } from '../../contexts/FlowContext';
import LoginPage from '../../pages/CarelonRx/login/LoginPage';
import ChangePasswordPage from '../../pages/CarelonRx/changePassword/ChangePasswordPage';
import MfaSelectionPage from '../../pages/CarelonRx/mfa/MFASelectionPage';
import SecurityVerificationPage from '../../pages/CarelonRx/mfa/SecurityVerificationPage';
import TextVoiceSelectionPage from '../../pages/CarelonRx/mfa/TextVoiceSelectionPage';
import UsernameInputPage from '../../pages/CarelonRx/username/UsernameInputPage';
import ConfirmationPage from '../../pages/CarelonRx/username/ConfirmationPage';
import SuccessPage from '../../pages/CarelonRx/success/SuccessPage';
import UsernameSuccessPage from '../../pages/CarelonRx/username/UsernameSuccessPage';

const componentMap: Record<string, React.ComponentType> = {
  'WebADAuthStep': LoginPage,
  'ChangePasswordStep': ChangePasswordPage,
  'MFAMethodStep': MfaSelectionPage,
  'TextVoiceSelectionStep': TextVoiceSelectionPage,
  'MFAVerificationStep': SecurityVerificationPage,
  'UsernameInputStep': UsernameInputPage,
  'UsernameSuccessStep': UsernameSuccessPage,
  'ConfirmationStep': ConfirmationPage,
  'SuccessStep': SuccessPage
};

const FlowRouter: React.FC = () => {
  const { currentStep, isLoading, error } = useFlow();

  if (isLoading) {
    return null;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!currentStep) {
    return null;
  }

  const StepComponent = componentMap[currentStep.component];

  if (!StepComponent) {
    return <div>Component "{currentStep.component}" not found</div>;
  }

  return <StepComponent {...(currentStep.props || {})} />;

};

export default FlowRouter;
